import { render } from "./HeaderBase.vue?vue&type=template&id=004bbc20"
import script from "./HeaderBase.vue?vue&type=script&lang=js"
export * from "./HeaderBase.vue?vue&type=script&lang=js"

import "./HeaderBase.vue?vue&type=style&index=0&id=004bbc20&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__